module.exports = "import * as React from 'react'\nimport { mount } from 'enzyme'\nimport { ControlPanel } from './ControlPanel'\n\ndescribe('ControlPanel', () => {\n  it('posts message when button is clicked', () => {\n    const dom = mount(<ControlPanel />)\n    dom.closest('button').simulate('click')\n  })\n})\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!../examples/test-controller-with-plugin/src/components/ControlPanel.test.before.tsx
// module id = 676
// module chunks = 121848987090403